<template>
  <div v-if="enable" class="max-w-md lg:max-w-5xl mx-auto pb-16">
    <div class="bg-[#F4F4F4] rounded-2xl lg:rounded-[32px] py-[30px] px-5 lg:px-10 justify-center items-center mb-2">
      <div class="flex flex-col gap-y-2">
        <h2 class="text-left text-xl font-bold text-dark mr-4">
          Level: {{ level }}
        </h2>
        <h2 v-if="rebate" class="text-left text-xl font-bold text-dark mr-4">
          Rebate: {{ toPercent(rebate) }}%
        </h2>
        <template v-if="nextInfo">
          <hr/>
          <span class="text-left">
            The previous statistics will be calculated on the 1st of each month.
          </span>
          <h2 class="text-left text-xl font-bold text-dark mr-4">
            Next Month Level: {{ nextInfo.level }}
            <template v-if="!nextInfo.requiredValue">(MAX)</template>
          </h2>
          <h2 v-if="nextInfo.requiredValue" class="text-left text-xl font-bold text-dark mr-4">
            Upgrading to Next Level requires $ {{ nextInfo.requiredValue }}
          </h2>
          <div class="rounded-full border-primary border w-full h-3.5 mt-2">
            <div class="rounded-full bg-primary h-3" :style="`width:${nextInfo.percent}%`"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
  <!-- <div class="max-w-md lg:max-w-5xl mx-auto pb-16">
    <div class="bg-[#F4F4F4] rounded-2xl lg:rounded-[32px] py-[30px] px-5 lg:px-10 justify-center items-center mb-2">
      <div class="flex flex-col gap-y-2">
        <h2 class="text-left text-xl font-bold text-dark mr-4">
          Level: {{ '5' }}
        </h2>
        <h2 class="text-left text-xl font-bold text-dark mr-4">
          Rebate: {{ '5' }} %
        </h2>
        <hr/>
        <span class="text-left">
          The previous statistics will be calculated on the 1st of each month.
        </span>
        <h2 class="text-left text-xl font-bold text-dark mr-4">
          Next Month Level: {{ '2' }}
        </h2>
        <h2 class="text-left text-xl font-bold text-dark mr-4">
          Upgrading to Next Level requires $ {{ '123.22' }}
        </h2>
        <div class="rounded-full border-primary border w-full h-3.5 mt-2">
          <div class="rounded-full bg-primary h-3" :style="`width:20.55%`"></div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { getUserMembership } from '@/utils/api/card'
import Big from 'big.js'
export default {
  data () {
    return {
      enable: false,
      level: null,
      rebate: '',
      nextInfo: null
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    async getInfo () {
      try {
        const { enable, level, rebate, nextInfo } = await getUserMembership()
        this.enable = enable
        this.level = level
        this.rebate = rebate || ''
        this.nextInfo = nextInfo || null
      } catch (e) {
      }
    },
    toPercent (value) {
      try {
        return Big(value).times(100).toString()
      } catch (e) {
        return ''
      }
    }
  }
}
</script>
